// eslint-disable-next-line import/no-unresolved
import { TypographyProps } from '@altibox/design-system-component-lib/dist/components/typography/types';
import React, { FC } from 'react';

import { LinkTheme } from 'src/components/link/link-types';

import { StyledLink, StyledLinkProps } from './link.styled';

type Props = StyledLinkProps & React.AnchorHTMLAttributes<HTMLAnchorElement> & Omit<TypographyProps, 'component'>;

export const Link: FC<Props> = (props) => {
  const { $focusTheme = LinkTheme.LIGHT, ...rest } = props;

  return <StyledLink {...rest} $focusTheme={$focusTheme} component="a" />;
};
